import { render, staticRenderFns } from "./videochat.vue?vue&type=template&id=48dd5b9c&"
import script from "./videochat.vue?vue&type=script&lang=js&"
export * from "./videochat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports